import {buildUri} from "../../utils/dom";

export class ConfigurationService {
    
    #configuration;

    get uri() {
        return buildUri(v24Scheduler.serviceRegion, `/api/c/pagebehaviour`);
    }

    get schedulerSettings() {
        return this.#configuration?.schedulerSettings;
    }

    get showHierarchicalTreeView() {
        // console.log(`showHierarchicalTreeView: ${this.schedulerSettings.showHierarchicalTreeView}`)
        return this.schedulerSettings.showHierarchicalTreeView;
    }

    get use24hourClock() {
        return this.schedulerSettings.use24hourClock;
    }

    get sitename() {
        return this.#configuration?.sitename;
    }    
    
    get siteSection() {
        return this.#configuration?.siteSection;
    } 
    
    get culture() {
        return this.#configuration?.culture;
    }

    async getConfig({sitename, siteSection, culture, page}) {

        if (this.#configuration) {
            return;
        }

        const params = new URLSearchParams();

        if(!page) {
            throw new Error("page parameter is required");
        }

        params.append("v24p", page);
    
        if(sitename) {
           params.append("v24si", sitename);
        }

        if(siteSection) {
            params.append("v24sec", siteSection);
        }
        
        if(culture) {
            params.append("v24c", culture);
        }

        
        const uri = `${this.uri}?${params.toString()}`;
        try {
            
            this.#configuration =
                await fetch(uri).then(response => response.json());

        } catch (e) {
            throw new Error("api call failed");
        }
    }
}